<template>
  <div>
    <button @click="toggleRequestView">
      {{ selectedView || 'Start' }}
    </button>

    <RequestView name="request" v-if="selectedView === 'request'" />
    <ExpenseCategories name="expense" v-if="selectedView === 'expense'" />
    <ExpenseDocumentation name="expenseDocs" v-if="selectedView === 'expenseDocs'"/>
    <EventCategories name="event" v-if="selectedView === 'events'"/>
    <EventDocumentation name="eventDocs" v-if="selectedView === 'eventDocs'"/>
    <RequestSummary name="requestSummary" v-if="selectedView === 'requestSummary'" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { analyticsMixin } from '@/services/googleAnalytics'
import RequestView from '@/views/Request'
import ExpenseDocumentation from '@/views/requests/ExpenseDocumentation'
import ExpenseCategories from '@/views/requests/ExpenseCategories'
import EventDocumentation from '@/views/requests/EventDocumentation'
import EventCategories from '@/views/requests/EventCategories'
import RequestSummary from '@/views/requests/RequestSummary'

export default {
  name: 'Request',
  mixins: [analyticsMixin],
  components: {
    RequestView,
    ExpenseCategories,
    ExpenseDocumentation,
    EventCategories,
    EventDocumentation,
    RequestSummary
  },
  data() {
    return {
      selectedView: '',
      selectedOptions: ['request', 'expense', 'expenseDocs', 'event', 'eventDocs', 'requestSummary'],
    }
  },
  async created() {},
  methods: {
    toggleRequestView() {
      const random = Math.floor(Math.random() * this.selectedOptions.length);
      this.selectedView = this.selectedOptions[random]
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'defaultRequestFlow']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/flex-box';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/grant-circles';
</style>
